/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Empty_DescriptionInputs */

const en_projects_empty_description = /** @type {(inputs: Projects_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Write-ups are on the way. In the meantime, tell us about the work you would like to hand over.`)
};

const lv_projects_empty_description = /** @type {(inputs: Projects_Empty_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apraksti top. Pa to laiku pastāstiet par darbu, ko gribētu nodot tālāk.`)
};

/**
* | output |
* | --- |
* | "Write-ups are on the way. In the meantime, tell us about the work you would like to hand over." |
*
* @param {Projects_Empty_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_empty_description = /** @type {((inputs?: Projects_Empty_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Empty_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_empty_description(inputs)
	return en_projects_empty_description(inputs)
});